import {DecimalPipe} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {NavigationProgressService} from './navigation-progress.service';

@Component({
  selector: 'app-navigation-progress',
  imports: [DecimalPipe],
  templateUrl: './navigation-progress.component.html',
  styleUrl: './navigation-progress.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationProgressComponent {
  readonly progress = inject(NavigationProgressService);
}
